import React from "react";
import "./index.less";
import {
    PROBABILITY_COLORS,
    FIRST_STRIKE_COLORS,
    COLOR_ALL_RISK,
    COLOR_RISK
} from "../../../../lightningCommonFunc"; // 从新文件导入颜色常量
import { LightningColorArray, LightningSearchTypeEnum } from "@/util/cosntants";
import GradientBar from "../GradientBar/GradientBar";
import { RootState } from "@/redux/reducer/store";
import { useSelector } from "react-redux";
import GradientBarCopy from "../GradientBar/GradientBarCopy";
interface MapLegendProps {
    searchType: string | null;
    isVisible: boolean; // 控制图例是否显示
}

function getDynamicIcon(zoom: number, count?: number): google.maps.Icon {
    const size = 38; // 图标固定大小
    const viewBoxSize = 1024;
    const finalCount = count ?? "";

    // 圆形和数字的配置
    const circleRadius = 200; // 圆的半径（viewBox 单位）
    const circleFillColor = "#FFFFFF"; // 圆的填充颜色（白色）
    const circleStrokeColor = "#000000"; // 圆的描边颜色
    const circleStrokeWidth = 20; // 圆的描边宽度

    const fontSize = count ? 300 : 0; // 数字大小根据 count 是否存在而设定
    const textColor = "#000000"; // 数字颜色（黑色）
    const textStrokeColor = "#FFFFFF"; // 数字描边颜色（白色）
    const textStrokeWidth = 10; // 数字描边宽度

    const svg = `
        <svg width="${size}" height="${size}" viewBox="0 0 1024 1024"
             xmlns="http://www.w3.org/2000/svg">
            <path d="M377.9 114.1h358.3l-136.4 268 231.5 0.3-485.1 559.3 139.5-356.4H222.6z"
                  fill="#FED928" stroke="#000" stroke-width="20"/>
        </svg>
    `;

    return {
        url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
        scaledSize: new google.maps.Size(size, size),
        anchor: new google.maps.Point(size / 2, size / 2),
    };
}

const LightningSvg = ()=>{
    return(
        <svg width={20} height={20} viewBox="0 0 1024 1024"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M377.9 114.1h358.3l-136.4 268 231.5 0.3-485.1 559.3 139.5-356.4H222.6z"
                fill="#FED928" stroke="#000" strokeWidth="20"/>
        </svg>
    );
};



const MapLegend: React.FC<MapLegendProps> = ({ searchType, isVisible }) => {
    const windowWidth = useSelector((state: RootState) => state.lightningReducer.windowWidth);
    if (!isVisible) {
        return null; // 如果不可见，不渲染任何内容
    }

    const renderDetailedLegend = (colorsArray: { range: string; color: string }[]) => {
        return (
            <div className="detailed-legend-container">
                <div className="color-row">
                    {colorsArray.map((item, index) => (
                        <div key={index} className="color-square" style={{ backgroundColor: item.color }}></div>
                    ))}
                </div>
                <div className="range-row">
                    {colorsArray.map((item, index) => (
                        <div key={index} className="range-label">{item.range}</div>
                    ))}
                </div>
            </div>
        );
    };

    const renderLegendContent = () => {
        switch (searchType) {
            case LightningSearchTypeEnum.ALLCLEAR:
                return (
                    <>
                        <div className="legend-item">
                            <span className="color-box" style={{ backgroundColor: LightningColorArray.AllClear }}></span>
                            {/* <span className="legend-text">All Clear</span> */}
                            <span className="legend-text">Safe Areas (Next 5 Minutes)</span>
                        </div>
                        <div className="legend-item">
                            <span className="color-box" style={{ backgroundColor: LightningColorArray.Risk }}></span>
                            <span className="legend-text">Risk Areas (Next 5 Minutes)</span>
                        </div>
                    </>
                );
            case LightningSearchTypeEnum.DETECTED:
                return (
                    <div className="legend-item">
                        <span className="color-box"
                            style={{
                                // backgroundColor: LightningColorArray.DetectedStrike
                                border: "none"
                            }}
                        >
                            <LightningSvg />
                        </span>
                        <span className="legend-text">Strike</span>
                    </div>
                );
            case LightningSearchTypeEnum.FIRSTSTRIKE:
                return (
                    <>
                        {/* <div className="legend-title">First Strike Probability</div> */}
                        {/* {renderDetailedLegend(FIRST_STRIKE_COLORS)} */}
                        <div className="gradient-div">
                            <div className="gradientbar-title"
                                style={windowWidth>768 ? {minWidth:"117px"}: {minWidth:"92px"}}>
                                <div className="gradient-div-title">Minutes to Lightning</div>
                                <div className="gradient-div-title">(min)</div>
                            </div>
                            {/* <GradientBarCopy
                                colors={FIRST_STRIKE_COLORS}
                                title=""
                                startPercentage={10}
                                intervalCount={13}
                                barHeight={10}
                                circleSize={8}
                                searchType={LightningSearchTypeEnum.FIRSTSTRIKE}
                            /> */}
                            <GradientBar colors={FIRST_STRIKE_COLORS}
                                searchType={LightningSearchTypeEnum.FIRSTSTRIKE}
                                className="firstStrike-gradientBar-width"
                            />
                        </div>
                    </>
                );
            case LightningSearchTypeEnum.PROBABILITY: // 修正为 Probability，假设这是正确的拼写
                return (
                    <>
                        {/* <div className="legend-title">Lightning Probability</div> */}
                        {/* {renderDetailedLegend(PROBABILITY_COLORS)} */}
                        <div className="gradient-div">
                            <div className="gradientbar-title" style={{maxWidth:"70px",minWidth:"50px"}} >
                                <div className="gradient-div-title">Probability</div>
                                <div className="gradient-div-title">%</div>
                            </div>
                            {/* <GradientBarCopy
                                colors={PROBABILITY_COLORS}
                                title="Probability %"
                                startPercentage={2}
                                intervalCount={21}
                                barHeight={10}
                                circleSize={8}
                                searchType={LightningSearchTypeEnum.PROBABILITY}
                            /> */}
                            <GradientBar
                                colors={PROBABILITY_COLORS}
                                searchType={LightningSearchTypeEnum.PROBABILITY}
                                className="probability-gradientBar-width"
                            />
                        </div>

                    </>
                );
            default:
                return null; // 其他类型不显示
        }
    };

    return (
        <div
            className="map-legend-container"
            style={{
                width: searchType === LightningSearchTypeEnum.ALLCLEAR ||
                        searchType === LightningSearchTypeEnum.DETECTED
                    ? "auto"
                    : "92%",
            }}
        >
            {renderLegendContent()}
        </div>
    );
};

export default MapLegend;